<template>
    <span @click='fn' :class="activeClass ? 'class-a' : 'class-b' ">{{btn_text}}</span>
</template>

<script>
    export default {
        name: "SendMsg",//发送短信
        data () {
            return {
                time:0,
                activeClass:true
            }
        },
        props:['deftext','second','fn'],
        methods:{
            run() {
                this.activeClass=false;
                this.time = this.second;
                this.timer();
            },
            timer(){
                if (this.time > 0) {
                    this.time--;
                    setTimeout(this.timer, 1000);
                }
            }
        },
        computed:{
            btn_text:function() {
                let that=this;
                if(this.time > 0 ){
                    return this.time + 's后重新发送'
                }else{
                    that.activeClass=false;
                    return this.deftext;
                }
            }
        }
    }
</script>

<style scoped>
    .class-a{
        color:#888
    }
    .class-b{
        color:#888;
    }
</style>

